import { Button } from "@mui/material";
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import HorizontalLine from "./HorizontalLine";
import { useInView } from "react-intersection-observer";
import { useAnimation } from "framer-motion";
import ParticlesBg from "./particlesBg/PartclesBg";
import { resumeLink } from "../config/ResumeLink";

const About = ({ aboutRef }) => {
  const { ref, inView } = useInView({ thresold: 0.1 });
  const [ref1, inView2] = useInView({ thresold: 0.01 });
  const animation = useAnimation();
  const imgAnimation = useAnimation();
  const boxAnimation = useAnimation();
  useEffect(() => {
    if (inView2) {
      console.log("start");
      boxAnimation.start({
        x: [-200, 50, 0],
        rotate: 0,
        opacity: 1,

        transition: {
          ease: "easeInOut",
          delay: 0.1,
          duration: [0.6],
        },
      });
    } else {
      console.log("end");
      boxAnimation.start({
        x: [-100, -100, -300],
        opacity: 0,
        // rotate: -80,

        transition: {
          ease: "easeIn",
          duration: 0.1,
        },
      });
    }
  }, [inView2]);

  useEffect(() => {
    if (inView) {
      imgAnimation.start({
        scale: 1,
        opacity:1,
        
        

        transition: {
          ease: "easeInOut",
          delay: 0.2,
          duration: .5,
        },
      });
      animation.start({
        opacity: 1,
        y: 0,
        transition: {
          ease: "easeInOut",
          duration: 1,
          delay: 0.2,
        },
      });
    } else {
      animation.start({
        opacity: 0,
        y: 80,
      });
      imgAnimation.start({
        scale: 0,
        opacity:0
      });
    }
  }, [inView]);
  return (
    <div>
      <ParticlesBg />
      <div ref={aboutRef} className="pt-32 px-2 lg:px-20 space-y-10 ">
        <HorizontalLine section={"About"} />

        <motion.div
          animate={boxAnimation}
          ref={ref1}
          className="flex flex-col lg:flex-row px-10 bg-black justify-center lg:space-x-10 items-center bg-opacity-50 py-5 rounded-xl border-gray-800 shadow-2xl shadow-blue-300 "
        >
          <div className="flex flex-col items-center  ">
            <motion.img
              ref={ref}
              animate={imgAnimation}
              className="rounded-full"
              src="https://res.cloudinary.com/zarmariya/image/upload/v1659193171/txru3w9ngtlsdnv6onym.png"
              alt="Ashok zarmariya"
            />
          </div>

          <motion.div
            animate={animation}
            className="flex flex-col items-center justify-center py-5"
          >
            <p
              ref={ref}
              className="w-64 lg:w-[80vh] text-sm lg:text-xl text-white mb-10 text-center"
            >
              A focused, full-stack web developer who have project leading
              experience during masai journey. Capable of working on independent
              projects. Looking to prove his skills and talents in a challenging
              work environment.
            </p>
            <Button className="mt-5" variant="outlined">
              <a href={resumeLink} target="-blank">
                Resume
              </a>
            </Button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default About;
//fixed